import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Media from 'react-responsive';
import styles from './FilterBar.scss';
import Checkbox from '../../Checkbox/Checkbox'
import Dropdown from 'react-dropdown';
import SortLabel from 'src/components/SortLabel/SortLabel';
import map from 'lodash/map';
import {Col, Row, Container} from 'src/components/Common/reactstrap/lib';


const bestOfferOptions = [
  'дешевые в начале',
  'самые быстрые в начале',
  'с наибольшей вероятностью в начале',
];

export default class FilterBar extends Component {

  filterSupplier = (value) => this.props.filterSupplier(value);

  onBestOffersChange = ({ value }) => this.props.filterBestOffers(value);

  render() {
    const {
      inStock,
      filterInStock,
      filterPriceMinValue,
      filterPriceMaxValue,
      supplierFilterValues,
      bestOfferValue,
      foundDetailOffers,
    } = this.props;

    const supplierFilterOptions = map(foundDetailOffers, (o) => ({
      value: o.supplier.supplierName,
      label: o.supplier.supplierName,
    }));

    return (
      <div className={styles.root}>
        <Col sm={3}>
          <span style={{marginLeft:'-15px'}}>Цена</span>
        <span className="ml-2">
          <input
            className={styles.number_input}
            placeholder="0"
            type="number"
            onChange={(e) => filterPriceMinValue(+e.target.value)}
          />

          <span>&mdash;</span>

          <input
            className={styles.number_input}
            placeholder="100 000"
            type="number"
            onChange={(e) => filterPriceMaxValue(+e.target.value)}
          />

          <span className="m-r-1 price">&#8381;</span>
        </span>
        </Col>
        <Col sm={2}>
          <Checkbox text="в наличии" onClick={() => filterInStock(!inStock)} />
        </Col>

        <Col sm={2} className={styles.dropdown} >
          <SortLabel
            multiple
            onChange={this.filterSupplier}
            options={supplierFilterOptions}
            value={supplierFilterValues}
            placeholder="Поставщик"
          />
        </Col>

        <SortLabel isAsc={false} className="col col-sm-1">Бренд</SortLabel>

        <Col className={styles.dropdown} sm={{size:2, offset:2}} >
          <Dropdown
            onChange={this.onBestOffersChange}
            options={bestOfferOptions}
            value={bestOfferValue}
            placeholder="Лучшие предложения в начале"
          />
        </Col>

      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchResults/elements/FilterBar.jsx
 **/